import { createLayoutApp } from "../layout/createLayoutApp";
import Breadcrumb from "@/common/controls/Breadcrumb.vue";
import CmsNewsListAppDestop from "../cmsNewsList/CmsNewsListAppDestop.vue";
import { setDocumentControllerType } from "../util/controllerHelpers";

const breadcrumbElement = document.getElementById("cms-news-list__breadcrumb");
if (breadcrumbElement) {
  const parsedItems = JSON.parse(breadcrumbElement.getAttribute("data-view-model") ?? "{}");
  const items = Object.entries(parsedItems).map((item, index) => ({
    id: index,
    text: item[0],
    link: item[1],
  }));

  const breadcrumbApp = createLayoutApp(Breadcrumb, { items });
  breadcrumbApp.mount(breadcrumbElement);
}

const mountEl = document.getElementById("cms-news-list");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  setDocumentControllerType("desktop");
  const raw = mountEl.getAttribute("data-view-model");
  const viewModel = raw ? JSON.parse(raw) : null;
  const app = createLayoutApp(CmsNewsListAppDestop, { viewModel });
  app.config.globalProperties.$mobile = false;
  app.mount(mountEl);
}